import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/app", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-black grain">
      <div
        className="absolute inset-0 opacity-30 bg-cover bg-center"
        style={{ backgroundImage: 'url(https://images.pexels.com/photos/6485524/pexels-photo-6485524.jpeg)' }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />
      <div className="relative z-10 flex flex-col min-h-screen">
        <header className="px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-kinetic" />
            <span className="font-sans font-extrabold tracking-tight text-white text-xl">INDIEWOOD</span>
            <span className="mono text-[10px] text-black bg-kinetic px-1.5 py-0.5 rounded-sm font-bold" data-testid="version-badge">TRIBE 1.0</span>
          </div>
          <span className="mono text-white/40">THE · INDIE · MEGAPLEX · SAAS</span>
        </header>

        <main className="flex-1 flex items-center px-8">
          <div className="max-w-5xl">
            <div className="mono text-kinetic mb-6">[ INFRASTRUCTURE FOR INDEPENDENT CULTURE ]</div>
            <h1 className="text-5xl sm:text-7xl lg:text-8xl font-extrabold tracking-tight text-white leading-[0.95]">
              Tell your stories.<br />Then <span className="text-kinetic">sell</span> them.
            </h1>
            <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed">
              INDIEWOOD is a SaaS megaplex for independent creators — stream your content, own your box office,
              network with studios & investors, and run your studio with built-in tools. Artist to audience.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Button data-testid="login-google-btn" onClick={handleLogin} className="kinetic-btn rounded-sm px-8 h-12 text-base">
                Continue with Google →
              </Button>
              <span className="mono text-white/40">SECURED · OAUTH · NO PASSWORDS</span>
            </div>

            <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 max-w-3xl">
              {[
                ["STREAM", "DIRECT TO AUDIENCE"],
                ["BOX OFFICE", "PPV · RENT · SUBS"],
                ["NETWORK", "MAKERS ↔ STUDIOS"],
                ["TOOLS", "ERP & CREATIVE"],
              ].map(([k, v]) => (
                <div key={v} className="bg-black p-5">
                  <div className="font-sans text-2xl font-extrabold text-white">{k}</div>
                  <div className="mono text-white/50 mt-2">{v}</div>
                </div>
              ))}
            </div>
          </div>
        </main>

        <footer className="px-8 py-6 mono text-white/30 flex justify-between">
          <span>© INDIEWOOD · {new Date().getFullYear()}</span>
          <span>ARTIST · TO · AUDIENCE</span>
        </footer>
      </div>
    </div>
  );
}
